import styled from 'styled-components'

export const StyledSectionCta = styled.div`
    display: flex;
    justify-content: center;
`
